import React from "react";
import { BrowserRouter } from "react-router-dom";

const PositionDetails = () => {
  return <BrowserRouter>PositionDetails</BrowserRouter>;
};

export default PositionDetails;
